import { BoardItemController } from './board-item.controller'

function boardItem () {
  return {
    restrict: 'E',
    scope: {
      board: '='
    },
    templateUrl: '/workflow/directives/board-item/board-item-directive.html?$$REVISION$$',
    controller: BoardItemController
  }
}

export { boardItem }
